import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import MainLayoutContainer from 'containers/MainLayout'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import PlanTypesTable from './components/Table'
import { CreatePlanTypeButton } from 'components/CTAs/index'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// context
import { PlanTypesPageContext } from 'containers/PlanTypes/layers/API'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const PlanTypes = () => {
  const { isLoading } = React.useContext(PlanTypesPageContext)

  return (
    <>
      <Helmet>
        <title>Skefto - Plan Types</title>
      </Helmet>
      <MainLayoutContainer CTA={<CreatePlanTypeButton />} isLoading={isLoading}>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <PlanTypesTable />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default PlanTypes
